import { render, staticRenderFns } from "./DeviceStandardSetting.vue?vue&type=template&id=0d641cc1&scoped=true&"
import script from "./DeviceStandardSetting.vue?vue&type=script&lang=js&"
export * from "./DeviceStandardSetting.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStandardSetting.vue?vue&type=style&index=0&id=0d641cc1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d641cc1",
  null
  
)

export default component.exports